
<fieldset>
  <legend class="form__label pb-8">Birth date</legend>
  <HelperText customClasses="-mt-4 mb-16 -ml-4" text="This information will not be visible on your profile" />
  <div class="-mt-4 inline-flex">
    <poppins-text-field
      id="month"
      v-model="form.month"
      labelName="MM"
      name="dob-month"
      type="text"
      maxlength="2"
      pattern="[0-9]*"
      class="mb-24 mr-18 w-5.5rem"
      inputmode="numeric"
      aria-label="Birth month"
      required
      :status="formStatuses.month"
      :limit-input-to-pattern="true"
      @blur="validateMonth"
    />
    <poppins-text-field
      id="day"
      v-model="form.day"
      labelName="DD"
      name="dob-day"
      type="text"
      maxlength="2"
      pattern="[0-9]*"
      class="mb-24 mr-18 w-5.5rem"
      inputmode="numeric"
      aria-label="Birth date"
      required
      :status="formStatuses.day"
      :limit-input-to-pattern="true"
      @blur="validateDay"
    />
    <poppins-text-field
      id="year"
      v-model="form.year"
      labelName="YYYY"
      name="dob-year"
      type="text"
      maxlength="4"
      pattern="[0-9]*"
      class="mb-24 w-6.5rem"
      inputmode="numeric"
      aria-label="Birth year"
      required
      :status="formStatuses.year"
      :limit-input-to-pattern="true"
      @blur="validateYear"
    />
  </div>
  <div v-if="formStatusesErrors" class="-mt-16 mb-16">
    <div v-for="key in formStatusesErrors" :key="key" class="flex relative">
      <HelperText :id="key" :status="0" :text="helperText(0, key)" />
    </div>
  </div>
</fieldset>
